import axios from 'axios'
import { reduce } from 'lodash'
import { useEffect, useRef, useState } from 'react'

import StadiumRemote from '../remote/stadiumRemote'
import createDataDogLog from '../utils/datadog'

export const QR_PAY_ERROR_MESSAGE = 'QR code charge declined. Check payment and try again.'

const useGetQRBalance = () => {
  const [dataLoading, setLoading] = useState(false)
  const [dataSucceeded, setSuccess] = useState(false)
  const [dataFailed, setFailed] = useState(false)
  const [qrBalance, setQRBalance] = useState()
  const [vaultedCard, setVaultedCard] = useState(false)
  const [isExpired, setIsExpired] = useState(false)
  const [affiliationUuids, setAffiliationUuids] = useState([])
  const [userUuid, setUserUuid] = useState(null)
  const cancelTokenRef = useRef()

  useEffect(() => {
    cancelTokenRef.current = axios.CancelToken.source()

    return () => {
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel()
      }
    }
  }, [])

  const resetQRState = () => {
    setQRBalance(0)
    setVaultedCard(false)
    setLoading(false)
    setSuccess(false)
    setAffiliationUuids([])
    setUserUuid(null)
  }

  const getQRBalance = (qrCode) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    StadiumRemote.getQRBalance(qrCode)
      .then((result) => {
        const qrBalance = reduce(
          result?.data,
          (total, vcAmount) => {
            const addedValue = typeof vcAmount !== 'number' ? 0 : vcAmount
            return total + addedValue
          },
          0,
        )

        // vaulted card returns "null" and when there are neither VC or vaulted card, it returns zero
        const vaultedCard = result?.data?.shift4Token !== undefined && result?.data?.shift4Token !== 0
        const affiliationUuids = result?.data?.affiliationUuids ?? []

        setQRBalance(qrBalance)
        setVaultedCard(vaultedCard)
        setLoading(false)
        setSuccess(true)
        setAffiliationUuids(affiliationUuids)
        setUserUuid(result?.data?.userUuid)
      })
      .catch((err) => {
        if (axios.isCancel(err)) return

        const errorMessage = err?.response?.data?.errorMessage ?? err.message
        const isExpired = errorMessage?.includes('expired')

        createDataDogLog('error', QR_PAY_ERROR_MESSAGE, { qrCode, errorMessage })
        setLoading(false)
        setFailed(true)
        setIsExpired(isExpired)
      })
  }

  return [
    getQRBalance,
    { qrBalance, vaultedCard, dataLoading, dataSucceeded, dataFailed, isExpired, affiliationUuids, userUuid, resetQRState },
  ]
}

export default useGetQRBalance
